<template>
  <div v-if="result" v-loading="loading" class="answer-result-wrap">
    <div class="answer-result-title">
      <h5>{{ result.subject_title }}</h5>
    </div>

    <mu-container>
      <h3>
        答题情况如下
        <small>（{{ result.end_time }}）</small>
      </h3>
    </mu-container>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>类型</th>
          <th>正确</th>
          <th>错误</th>
          <th>未完成</th>
          <th>{{ isPractice ? "正确率" : "得分" }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="title">单选题:</td>
          <td class="">
            {{ result.singleChoice.true }}
          </td>
          <td>
            {{ result.singleChoice.false }}
          </td>
          <td>
            {{ result.singleChoice.empty }}
          </td>
          <td>
            {{ isPractice ? result.singleChoice.percent : result.singleChoice.score }}
          </td>
        </tr>
        <tr>
          <td class="title">判断题:</td>
          <td class="">
            {{ result.trueOrFalseQuestion.true }}
          </td>
          <td>
            {{ result.trueOrFalseQuestion.false }}
          </td>
          <td>
            {{ result.trueOrFalseQuestion.empty }}
          </td>
          <td>
            {{
              isPractice
                ? result.trueOrFalseQuestion.percent
                : result.trueOrFalseQuestion.score
            }}
          </td>
        </tr>
        <tr>
          <td class="title">多选题:</td>
          <td class="">
            {{ result.multipleChoice.true }}
          </td>
          <td>
            {{ result.multipleChoice.false }}
          </td>
          <td>
            {{ result.multipleChoice.empty }}
          </td>
          <td>
            {{ isPractice ? result.multipleChoice.percent : result.multipleChoice.score }}
          </td>
        </tr>
        <tr>
          <td class="title">
            {{ isPractice ? "正确率:" : "得分/总分:" }}
          </td>
          <td class="" colspan="4">
            <span v-if="isPractice">
              {{ result.total_percent }}
            </span>
            <span v-else>
              <span class="main-title">{{ result.score }}</span>
              /
              {{ result.total_score }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <mu-container class="button-wrapper">
      <div v-if="$route.query.is_fresh == 1 || $route.query.is_fresh == 2">
        <mu-flex justify-content="center" align-items="center">
          <mu-button
            v-if="$route.query.is_fresh == 1"
            round
            color="#214ecf"
            @click="
              $router.replace({
                path: '/module-exam',
                query: { chapter_id: $route.query.subject_id },
              })
            "
          >
            再练一次
          </mu-button>
          <mu-button
            v-if="$route.query.is_fresh == 2"
            round
            color="#214ecf"
            @click="
              $router.replace({
                path: '/mock-exam',
                query: { subject_id: $route.query.subject_id },
              })
            "
          >
            再练一次
          </mu-button>
        </mu-flex>

        <mu-flex justify-content="center" align-items="center">
          <mu-button
            round
            color="#214ecf"
            @click="
              $router.push({
                path: '/historical-answer',
                query: { answer_id: result.answer_id, type: 'test' },
              })
            "
          >
            全部解析
          </mu-button>
        </mu-flex>

        <mu-flex justify-content="center" align-items="center">
          <mu-button
            round
            color="#214ecf"
            @click="
              $router.push({
                path: '/historical-answer',
                query: { answer_id: result.answer_id },
              })
            "
          >
            错题集合
          </mu-button>
        </mu-flex>
        <mu-flex justify-content="center" align-items="center">
          <mu-button round color="#214ecf" @click="$router.go(-1)"> 返回目录 </mu-button>
        </mu-flex>
      </div>

      <div v-else>
        <mu-flex justify-content="center" align-items="center">
          <mu-button
            round
            color="#214ecf"
            @click="
              $router.push({
                path: '/historical-answer',
                query: { answer_id: result.answer_id, type: $route.query.type },
              })
            "
          >
            查看{{ $route.query.type === "wrong" ? "错题" : "答题" }}
          </mu-button>
        </mu-flex>
        <mu-flex justify-content="center" align-items="center">
          <mu-button round color="#214ecf" @click="$router.go(-1)"> 返回目录 </mu-button>
        </mu-flex>
      </div>
    </mu-container>
  </div>
</template>

<script>
import { fetchMockTestAnswerStatistic } from "@/api/index";
export default {
  nmae: "answerResult",
  components: {},
  props: {},
  data() {
    return {
      loading: true,
      isPractice: false,
      sort: {
        name: "",
        order: "asc",
      },
      result: null,
      columns: [
        {
          title: "类型",
          name: "name",
        },
        {
          title: "分数",
          name: "score",
          align: "center",
        },
      ],
      list: [
        {
          name: "总分",
          align: "center",
          score: 100.0,
        },
        {
          name: "得分",
          align: "center",
          score: 518.0,
        },
        {
          name: "判断题",
          align: "center",
          score: 518.0,
        },
        {
          name: "单选题",
          align: "center",
          score: 518.0,
        },
        {
          name: "多选题",
          align: "center",
          score: 518.0,
        },
      ],
    };
  },
  // mounted() {
  //   console.log('mounted')
  // },
  activated() {
    this.isPractice = this.$route.query.answer_type == "practice";
    this.getResult();
  },
  methods: {
    async getResult() {
      this.loading = true;
      const result = await fetchMockTestAnswerStatistic({
        answer_id: this.$route.query.answer_id,
      });
      if (this.isPractice) {
        result.singleChoice.percent = this.getPercent(result.singleChoice);
        result.trueOrFalseQuestion.percent = this.getPercent(result.trueOrFalseQuestion);
        result.multipleChoice.percent = this.getPercent(result.multipleChoice);
        result.total_percent = this.getTotalPercent(result);
      }
      this.result = result;
      this.loading = false;
    },
    getPercent(obj) {
      const total = obj.true + obj.false + obj.empty;
      if (total == 0) return "--";
      return ((obj.true * 100) / total).toFixed(1) + "%";
    },
    getTotalPercent(obj) {
      const singleChoice =
        obj.singleChoice.true + obj.singleChoice.false + obj.singleChoice.empty;
      const trueOrFalseQuestion =
        obj.trueOrFalseQuestion.true +
        obj.trueOrFalseQuestion.false +
        obj.trueOrFalseQuestion.empty;
      const multipleChoice =
        obj.multipleChoice.true + obj.multipleChoice.false + obj.multipleChoice.empty;
      const total = singleChoice + trueOrFalseQuestion + multipleChoice;
      return (
        (
          ((obj.singleChoice.true +
            obj.trueOrFalseQuestion.true +
            obj.multipleChoice.true) *
            100) /
          total
        ).toFixed(1) + "%"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.material-icons {
  position: relative;
  top: 2px;
  left: -1px;
  font-size: 16px;
}
</style>

<style lang="scss">
// 题库标题
.answer-result-title {
  width: 100vw;
  height: 45px;
  line-height: 45px;
  text-align: center;
  //   position: fixed;
  background-color: #214ecf;
  color: #fff;
  font-size: 20px;
  //   top: 0;
  //   left: 0;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
  // 题库 标题文字
  h5 {
    height: 45px;
    line-height: 45px;
    // height: 25px;
    // line-height: 32px;
    margin: 0;
    font-size: 16px;
  }
  // 题库 答题进度
  p {
    height: 20px;
    line-height: 20px;
    margin: 0;
    font-size: 12px;
  }
}

.answer-result-wrap {
  p {
    text-align: center;
  }
}

.table {
  width: 100%;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
  text-align: center;
}
.table-bordered {
  border: 1px solid #dee2e6;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.main-title {
  //   font-size: 1.2em;
  font-weight: bold;
}

.bright-green {
  color: #558b2f;
}

.bright-red {
  color: #c62828;
}

.button-wrapper {
  margin: {
    bottom: 20px;
    top: 20px;
  }
  text-align: center;
  .mu-button {
    margin: 8px;
    vertical-align: middle;
  }
  .mu-raised-button .mu-button-wrapper {
    width: 140px;
  }
  a.mu-button {
    text-decoration: none;
  }
}
</style>
